import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            width: '100%',
            '& .MuiDataGrid-root': {
                border: 'none',
                borderBottom: `1px solid ${theme.palette.divider}`,
            },
            '& .MuiDataGrid-cell': {
                padding: theme.spacing(0.5),
            },
        },
        checkbox: {
            padding: `0 0 0 ${theme.spacing(2)} !important`,
        },
        input: {
            paddingLeft: theme.spacing(0.25),
        },
        inputLabel: {
            display: 'none',
        },
    }
})

export default useStyles
